import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ImageGalleryBlock2 as Block } from "./ImageGalleryBlock2";
import { defaultData } from "./ImageGalleryBlock2DefaultData";
import { meta } from "./ImageGalleryBlock2Metadata";
import previewImage from "./image_gallery_block_2_preview.png";

export const ImageGalleryBlock2: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: previewImage,
  },
  defaultData,
  meta,
};
